hrd.AbstractRichEditor = hrd.Class.extend({
	elementName: '',
	/** @type {CKEDITOR.editor} */
	instance: undefined,
	/** @type {Promise} */
	onInstanceCompletePromise: undefined,
	/** @type {hrd.AbstractFormDashlet} */
	dashlet: undefined,
	/** @type {hrd.Form} */
	formInstance: undefined,

	init: function(elementName, options) {
		const defaults = {
			impl: 'hrd.AbstractRichEditor'
		};

		this._super($.extend({}, defaults, options));

		const deferred = $.Deferred();
		const textAreaHeight = $(`[data-name="${elementName}"]`).height();

		this.onInstanceCompletePromise = deferred.promise();
		this.dashlet = this.settings.dashlet;
		this.formInstance = this.settings.formInstance;
		this.elementName = elementName;

		const editorConfig = $.extend({ height: textAreaHeight, language: 'it' }, this.config(), this.settings.config, {
			extraPlugins: `editorplaceholder,colordialog,${this.config().extraPlugins || ''}`,
		});

		this.instance = CKEDITOR.replace(elementName, editorConfig);

		if (this.instance) {
			this.instance.on('instanceReady', () => {
				this.instance.removeMenuItem('paste');

				this.startEvents(this.events());
				this.addMenuItems(this.menuItems());
				this.toggleReadOnlyMode(this.config().readOnly);

				if($('.chroma-flow').length > 0) {
					const $iframe = $(`[data-name="${elementName}"]`)
						.parent()
						.find('iframe');

					this.applyThemesToRichEditor($iframe);

					$iframe
						.one('load', (e) => {
							this.applyThemesToRichEditor(e.currentTarget);
						});
				}

				deferred.resolve();
			});
		}
	},

	applyThemesToRichEditor: function(iframe) {
		const toolbox = new hrd.Toolbox();
		const useSideBarMenu = toolbox.get('globals.prefs.tenant.layout.useSideBarMenu', hrd);
		const theme = toolbox.get('globals.prefs.tenant.layout.theme', hrd);
		const iframeDocument = $(iframe).contents().get(0);

		if(useSideBarMenu && theme) {
			applyLayoutTheme(theme, { target: iframeDocument.documentElement })
		}

		$('body', $(iframe).contents()).prop('style').setProperty('background-color', 'var(--color-gray-0)');
		$('body', $(iframe).contents()).prop('style').setProperty('color', 'var(--color-gray-1000)');
	},

	isLoaded: function() {
		return !!this.instance;
	},
	config: function() {
		return {};
	},
	events: function() {
		return [];
	},
	menuItems: function() {
		return [];
	},
	startEvents: function(events = []) {
		events.forEach(event => {
			const { name, on } = event;

			this.instance.on(name, (event) => on(event, this.elementName));
		});
	},
	addMenuItems: function(itemsPromise) {
		itemsPromise = itemsPromise || $.when([]);
		return itemsPromise.then(items => {
			if (items.length > 0) {
				// filter items by visibility
				items = items.filter(item => (!item.hideWhen));

				const groups = new Set(items.map((item) => item.group));

				let enabledItems = {};

				items.forEach((item) => {
					const { name, enabledWhen } = item;

					enabledItems[name] = enabledWhen ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED;
				});

				groups.forEach((group, index) => this.instance.addMenuGroup(group, index));

				items.forEach((item, index) => {
					const { name, label, group, command, icon } = item;

					this.instance.addCommand(command.name, {
						exec: command.exec
					});
					this.instance.addMenuItem(name, {
						label, group, command: command.name, order: index, icon
					});
				});

				this.instance.contextMenu.addListener(() => enabledItems);
			}
			return $.when(items);
		});
	},
	startLoading: function() {
		const $editor = $(`[data-name="${this.elementName}"]`).next();
		const $loadingOverlay = $(`
		<div class="editor-loading-overlay">
			<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
				<circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
				<path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
			  </svg>
		</div>`);

		if (!$editor.exists() || $editor.find('.editor-loading-overlay').exists()) return;

		$editor.prepend($loadingOverlay);
	},
	stopLoading: function() {
		const $editor = $(`[data-name="${this.elementName}"]`).next();
		const $loadingOverlay = $('.editor-loading-overlay', $editor);

		if (!$editor.exists() || !$loadingOverlay.exists()) return;

		$loadingOverlay.remove();
	},
	enableContextMenu: function() {
		this.instance.config.enableContextMenu = true;
	},
	disableContextMenu: function() {
		this.instance.config.enableContextMenu = false;
	},
	enableButton: function(command) {
		const button = this.instance.getCommand(command);

		if (button) {
			button.enable();
		}
	},
	disableButton: function(command) {
		const button = this.instance.getCommand(command);

		if (button) {
			button.disable();
		}
	},
	permanentlyDisableButton: function(command) {
		const button = this.instance.getCommand(command);

		if (button) {
			button.disable();
			button.removeAllListeners();
		}
	},
	insertText: function(text) {
		this.instance.insertText(text);
	},
	insertHtml: function(html) {
		this.instance.insertHtml(html);
	},
	prependHtml: function(html) {
		this.instance.focus();

		const range1 = this.instance.createRange();
		range1.moveToPosition(range1.root, CKEDITOR.POSITION_AFTER_START);
		this.instance.getSelection().selectRanges([range1]);

		this.instance.execCommand('enter');

		const range2 = this.instance.createRange();
		range2.moveToPosition(range2.root, CKEDITOR.POSITION_AFTER_START);
		this.instance.getSelection().selectRanges([range2]);

		this.insertHtml(html);
	},
	appendHtml: function(html) {
		this.instance.focus();

		const range = this.instance.createRange();
		range.moveToPosition(range.root, CKEDITOR.POSITION_BEFORE_END);
		this.instance.getSelection().selectRanges([range]);

		this.instance.execCommand('enter');

		this.insertHtml(html);
	},
	toggleReadOnlyMode: function(readOnly) {
		this.instance.setReadOnly(!!readOnly);
	},
});